// engine
import { ArController, gameDispatcher, userDispatcher } from '@aceroll/core';

// hacksaw
import { responseService, uiService } from '@aceroll/platform-hacksaw';

// library
import { slotDispatcher } from '@aceroll/core/library';

// services
import { scatterCounterService } from '../../services/scatter-counter-service';

export class SpinStop extends ArController {
	async onStart() {
		const serverEvent = responseService.getEvent();

		const { slotMachine } = this.context.currentLayout;
		const { gameType } = gameDispatcher.state;
		const { symbols } = serverEvent.data;

		slotDispatcher.updateSymbols(symbols, gameType, []);

		const anticipation = this.getAnticipation(symbols, '11');

		if (anticipation && userDispatcher.mode !== 'superTurbo' && !responseService.bonusBuy) {
			await slotMachine.anticipation(anticipation);
		} else {
			await slotMachine.stop();
		}

		scatterCounterService.reset();

		uiService.offShowResult(userDispatcher.slamStop);

		this.stop();
	}

	getAnticipation(symbols, scatterId) {
		let reelIndex = null;
		let scatterCount = 0;

		for (let i = 0; i < symbols.length - 1; i++) {
			if (scatterCount >= 2) {
				break;
			}

			const reel = symbols[i];

			for (let j = 0; j < reel.length; j++) {
				const cell = reel[j];

				if (cell !== scatterId) {
					continue;
				}

				scatterCount += 1;

				if (scatterCount >= 2) {
					reelIndex = i + 1;
					break;
				}
			}
		}

		return reelIndex;
	}
}
